import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { fromCarl } from 'src/app/store/common/common.selectors';
import { HeaderData } from 'src/app/utils/models/header-data.interface';

import { BrandLinkComponent } from '../brand-link/brand-link.component';
import { DealerLocatorComponent } from '../dealer-locator/dealer-locator.component';

@Component({
  selector: 'cc-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LetDirective, BrandLinkComponent, DealerLocatorComponent]
})
export class HeaderComponent {
  public readonly headerData$ = this.store.select(
    fromCarl.selectConfig<HeaderData>('header', {
      // german claim in use when market unknown, and therefore config-files cannot be resolved
      claim: 'https://assets.oneweb.mercedes-benz.com/global/1.16.0/images/svg/MB-wm_claim1DE_ra_n_web.svg',
      url: ''
    })
  );

  public constructor(private readonly store: Store) {}
}
